<template>
	<div id="app">
		<div id="fullpage">
			<div class="section" id="section0">
				<Video :sectionsIndex="sectionsIndex" />
			</div>
			<div class="section" id="section1">
				<div class="product-container">
					<div class="slide" v-bind="{'id': 'slide' + (index+1)}" v-for="(item, index) in product">
						<div class="photo">
							<div></div>
						</div>
						<div class="infomation-name">
							<h2>AI产品</h2>
							<h4>{{item.name}}</h4>
						</div>
						<div class="infomation-type">
							{{item.type}}
						</div>
						<div class="infomation-infos">
							<h3 v-bind="{'ref': item.type}">{{item.type}}</h3>
							<div v-bind="{'ref': item.type + 'title'}" class="title">功能特征</div>
							<ul>
								<li :key="item.type+i" v-bind="{'ref': item.type+i}" v-for="(t, i) in item.detail">{{i+1}}. {{t}}</li>
							</ul>
						</div>
					</div>

					<div class="fp-controlArrow fp-prev n-fp-controlArrow n-fp-prev"></div>
					<div class="fp-controlArrow fp-next n-fp-controlArrow n-fp-next"></div>
				</div>
			</div>
			<div class="section" id="section2">
				<Server />
			</div>
			<div class="section" id="section3">
				<About :sectionsIndex="sectionsIndex" />
			</div>
		</div>

		<div class="login fadeInScale">
			<h1>识加科技</h1>
			<img src="../../assets/images/logn.png" >
		</div>

		<div id="menu-bar" @click="menuVisible=true">
			<span class="title">菜单</span>
			<img src="../../assets/images/menu.png" alt="">
		</div>
		
		<div class="arrow twinkle" v-if="sectionsIndex < options.anchors.length-1" @click="next"></div>

		<div class="copyright fadeInUpBig" v-if="sectionsIndex < options.anchors.length-1">©2016-{{year}}  识加科技（上海）有限公司</div>
		
		<div class="menu" v-if="menuVisible" onmousemove="return false">
			<div class="mask" :class="{'mask-scale': menuVisible}"></div>
			<div class="close" @click="menuVisible = false"><span>关闭</span> <img src="../../assets/images/close.png" alt=""></div>
			<div class="menu-wapper" :class="{'menu-scale': menuVisible}">
				<div class="menu-column">
					<div class="menu-center">
						<h1>AI产品 <span><span></span><span></span><span></span></span></h1>
						<div @click="handlerAnchor('product', 0)"><a href="javascript:;">EKS339</a></div>
						<div @click="handlerAnchor('product', 1)"><a href="javascript:;">EKR200</a></div>
						<div @click="handlerAnchor('product', 2)"><a href="javascript:;">DSM</a></div>
						<div @click="handlerAnchor('product', 3)"><a href="javascript:;">ADAS</a></div>
						<div @click="handlerAnchor('product', 4)"><a href="javascript:;">BSD</a></div>
					</div>
				</div>

				<div class="menu-column">
					<div class="menu-center">
						<h1>行业解决方案 <span><span></span><span></span><span></span></span></h1>
						<div @click="handlerAnchor('server', 0)"><a href="javascript:;">行车安全解决方案</a></div>
						<div @click="handlerAnchor('server', 1)"><a href="javascript:;">车队培训解决方案</a></div>
					</div>
				</div>

				<div class="menu-column">
					<div class="menu-center">
						<h1>关于我们 <span><span></span><span></span><span></span></span></h1>
						<div @click="handlerAnchor('about')"><a href="javascript:;">企业介绍</a></div>
						<div @click="handlerAnchor('about')"><a href="javascript:;">联系方式</a></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Video from './video.vue'
	import Server from './server.vue'
	import About from './about.vue'
	import AntvG2 from '@/utils/antvg2.js'

	let myFullpage;
	let timer;

	let product = [
		{ name: '多功能安全培训终端', type: 'EKS339', detail: ['实名注册，公安人证核验', '200w高清摄像头，人脸识别登录', '身份证，驾驶证扫描识别', '在线培训视频观看', '岗中定期培训', '酒精检测考勤'] },
		{ name: '鸣笛右转弯检测', type: 'EKR200', detail: ['车辆鸣笛检测', '鸣笛录音上报', '车辆行驶轨迹记录', '全天候车速车速监控', '右转弯超速报警'] },
		{ name: '司机状态监控摄像头', type: 'DSM', detail: ['识别司机分神，左顾右盼', '识别抽烟行为', '识别打电话行为', '识别打哈欠，闭眼等疲劳驾驶', '有效判断驾驶员异常情况', '覆盖夜晚，雨雪等特殊天气坏境影响'] },
		{ name: '高级辅助驾驶系统', type: 'ADAS', detail: ['前车碰撞预警', '车道偏离预警', '车距过近报警', '闯红灯行为识别'] },
		{ name: '右侧盲区检测系统', type: 'BSD', detail: ['盲区行人碰撞预警', '车外行人声光报警'] },
	]

	let anchors = ['home', 'product', 'server', 'about'];

	let barDate = [
		{ type: '2014', value: 654, percent: 37.69 },
		{ type: '2015', value: 654, percent: 24.32 },
		{ type: '2016', value: 654, percent: 18.74 },
		{ type: '2017', value: 654, percent: 9.46 },
		{ type: '2018', value: 654, percent: 6.79 }
	]

	export default {
		name: 'index',
		components: { Video, Server, About },
		data() {
			return {
				year: new Date().getFullYear(),
				menuVisible: false,
				sectionsIndex: 0,
				swiperIndex: 0,

				product: product,
				barDate: barDate,
				options: {
					verticalCentered: false,
					css3: false,
					anchors: anchors,
					onLeave: this.onLeave,
					afterLoad: this.afterLoad,
					afterSlideLoad: this.afterSlideLoad,
					onSlideLeave: this.onSlideLeave
				}
			}
		},
		mounted() {
			myFullpage = new fullpage('#fullpage', this.options);

			AntvG2.Bar({
				el: 'mountNode',
				list: barDate,
				height: '350',
				position: ['type', 'percent'],
				title: '比例',
				padding: [40, 40, 40, 40]
			});
		},
		methods: {
			next() {
				if (this.sectionsIndex < anchors.length-1) {
					this.sectionsIndex++;
					window.fullpage_api.moveTo(anchors[this.sectionsIndex]);
				}
			},
			handlerAnchor(anchor, index) {
				anchors.map((item, i) => {
					if (item == anchor) {
						window.fullpage_api.moveTo(anchors[i], index);
					}
				})

				this.menuVisible = false;
			},
			onLeave(origin, destination) {
				this.sectionsIndex = destination.index;

				if (destination.index == 1) {
					document.querySelectorAll('.infomation-name h2')[0].classList.add('fadeInDown');
					document.querySelectorAll('.photo div')[0].classList.add('fadePhoto');

					setTimeout(() => {
						document.querySelectorAll('.infomation-name h2')[0].classList.remove('fadeInDown');
						document.querySelectorAll('.photo div')[0].classList.remove('fadePhoto');
					}, 2000);
				}
			},
			afterLoad(origin, destination) {
				if (destination.index == 2) {
					timer = setInterval(() => {
						window.fullpage_api.moveSlideRight();
					}, 5000);
				}else {
					clearInterval(timer);
				}

				// fnProductAnimate(this, destination);
			},
			onSlideLeave(origin, destination, direction) {
				product.map(item => {
					this.$refs[item.type].style.right = '-9999px';
					this.$refs[item.type + 'title'].style.right = '-9999px';

					item.detail.map((t, i) => {
						this.$refs[item.type + i].style.right = '-9999px';
					})
				})

				if (origin.index == 1) {
					this.swiperIndex = direction.index;
					document.querySelectorAll('.infomation-name h2')[this.swiperIndex].classList.add('fadeInDown');
					document.querySelectorAll('.photo div')[this.swiperIndex].classList.add('fadePhoto');

					setTimeout(() => {
						document.querySelectorAll('.infomation-name h2')[this.swiperIndex].classList.remove('fadeInDown');
						document.querySelectorAll('.photo div')[this.swiperIndex].classList.remove('fadePhoto');
					}, 2000);


					let type = product[this.swiperIndex].type;
					let _size = parseFloat(getStyle(document.querySelector('html'), 'fontSize'));
					let _right = 584*_size/192;

					if (window.innerWidth <= 1024) {
						this.$refs[type].style.right = 0;
						this.$refs[type + 'title'].style.left = (window.innerWidth - 70)/2 + 'px';

						product[this.swiperIndex].detail.map((item, index) => {
							this.$refs[type + index].style.right = 0;
						})
					}else{
						this.$refs[type].style.right = _right - this.$refs[type].offsetWidth + 'px';
						this.$refs[type + 'title'].style.right = _right - this.$refs[type + 'title'].offsetWidth + 'px';

						product[this.swiperIndex].detail.map((item, index) => {
							this.$refs[type + index].style.right = _right - this.$refs[type + index].offsetWidth + 'px';
						})
					}
				}
			}
		}
	}

	function fnProductAnimate(that, params) {
		if (params.index == 1) {
			let type = product[that.swiperIndex].type;
			let _size = parseFloat(getStyle(document.querySelector('html'), 'fontSize'));
			let _right = 584*_size/192;

			if (window.innerWidth <= 1024) {
				that.$refs[type].style.right = 0;
				that.$refs[type + 'title'].style.left = (window.innerWidth - 70)/2 + 'px';

				product[that.swiperIndex].detail.map((item, index) => {
					that.$refs[type + index].style.right = 0;
				})
			}else{
				that.$refs[type].style.right = _right - that.$refs[type].offsetWidth + 'px';
				that.$refs[type + 'title'].style.right = _right - that.$refs[type + 'title'].offsetWidth + 'px';

				product[that.swiperIndex].detail.map((item, index) => {
					that.$refs[type + index].style.right = _right - that.$refs[type + index].offsetWidth + 'px';
				})
			}
		}else{
			product.map(item => {
				that.$refs[item.type].style.right = '-9999px';
				that.$refs[item.type + 'title'].style.right = '-9999px';

				item.detail.map((t, i) => {
					that.$refs[item.type + i].style.right = '-9999px';
				})
			})
		}
	}

	function getStyle(obj, name) {
		return (obj.currentStyle || document.defaultView.getComputedStyle(obj, false))[name];
	}
</script>

<style lang="scss">
	@import '../../styles/fullpage.css';
	@import '../../styles/base.scss';
	
	@media screen and (min-width: 980px) {
		@import '../../styles/index.scss';
	}

	@media screen and (max-width: 980px) {
		@import '../../styles/media980.scss';
	}
</style>
